<template>
<div class="top">
    <div class="nav-box">
        <img
            src="../assets/images/logo-second.png"
            class="logo"
            alt=""
            srcset=""
        />
        <div class="nav">
            <div class="item" @click="linkTo('/index')">首页</div>
            <div class="item" :class="path == '/businessIntroduce' ? 'active' : ''" @click="linkTo('/businessIntroduce')">业务介绍</div>
            <div class="item" :class="path == '/productCenter' ? 'active' : ''" @click="linkTo('/productCenter')">产品中心</div>
            <div class="item" :class="path == '/newstendency' ? 'active' : ''" @click="linkTo('/newstendency')">新闻状态</div>
            <div class="item item-about" :class="
                path == '/aboutUs' ? 'active' : ''|| 
                path == '/companyInfo' ? 'active' : ''|| 
                path == '/cooperation' ? 'active' : ''|| 
                path == '/recruitInfo' ? 'active' : '' 
            ">
                <p @click="linkTo('/aboutUs')">关于我们</p>
                <div class="second">
                    <p @click="linkTo('/companyInfo')">企业信息</p>
                    <p @click="linkTo('/cooperation')">加盟合作</p>
                    <!-- <p @click="linkTo('/recruitInfo')">招聘信息</p> -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: "header",
    components: {
    },
    data() {
        return {
            httpUrl: process.env.VUE_APP_URL,
            path: "",
        };
    },
    methods: {
        UrlSearch() {
            let href = location.href.split("/#");
            this.path = href[1];
            console.log(this.path)
        },
        // 跳转
        linkTo(path,id) {
            this.$router.push({
                path: path,
                query: {
                    id:id
                },
            });
        },
    },
    watch: {
      $route(to, from) {
        this.UrlSearch();
      },
    },
    created(){
        this.UrlSearch();
    }
}
</script>
<style lang="less" scoped>
@import "../assets/css/base.less";
</style>